import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import CreateMatch from "./pages/CreateMatch";
import Composition from "./pages/Composition";
import Match from "./pages/Match";
import StatsJoueurs from "./pages/StatsJoueurs";
import PlayerDetail from "./pages/PlayerDetail";
import StatsEquipe from "./pages/StatsEquipe";
import ListeMatchs from "./pages/ListeMatchs";
import MatchDetail from "./pages/MatchDetail";
import LiveMatch from "./pages/LiveMatch";
import GestionJoueurs from "./pages/GestionJoueurs";
/* import Equipe from "./pages/Equipe";
import Caisse from "./pages/Caisse"; */

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/creatematch" element={<CreateMatch />} />
        <Route path="/match" element={<Match />} />
        <Route path="/composition" element={<Composition />} />
        <Route path="/joueurs" element={<StatsJoueurs />} />
        <Route path="/joueur/:playerId" element={<PlayerDetail />} />
        <Route path="/equipe" element={<StatsEquipe />} />
        <Route path="/matchs" element={<ListeMatchs />} />
        <Route path="/match-detail/:matchId" element={<MatchDetail />} />
        <Route path="/live" element={<LiveMatch />} />
        <Route path="/gestion-joueurs" element={<GestionJoueurs />} />
        {/* <Route path="/caisse" element={<Caisse />} /> */}
      </Routes>
    </Router>
  );
}

export default App;